import React from 'react';
import Kbd from './Kbd';

// The shortcut strip along the bottom of a keyboard-driven screen.
//
// Hidden from assistive tech: every shortcut it advertises is also exposed on
// the control itself via aria-keyshortcuts, so announcing them twice would just
// make the checklist noisier to listen to. Sighted keyboard users get the
// reminder; screen-reader users get it in context.
//
// `hints` is [{ key, label }].
export default function KeyHintBar({ hints = [] }) {
  if (!hints.length) return null;
  return (
    <div
      aria-hidden="true"
      style={{
        flexShrink: 0, display: 'flex', alignItems: 'center', gap: 'var(--space-4)',
        flexWrap: 'wrap', padding: 'var(--space-2) var(--space-4)',
        background: 'var(--surface-inset)', border: '1px solid var(--border-default)',
        borderRadius: 'var(--radius-md)',
      }}>
      {hints.map(h => (
        <div key={h.key + h.label} style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
          <Kbd>{h.key}</Kbd>
          <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>{h.label}</span>
        </div>
      ))}
    </div>
  );
}
